import { PartialRecord } from "../types/GeneralTypes";
import { ProposalResource } from "../types/Proposal";

const host = process.env.REACT_APP_BACKEND_URL;

export const RelapkaConverter:PartialRecord<keyof ProposalResource, (input:any) => unknown> = {
    content: (fileId: string) => {
        return host + "/public/files/" + fileId + "/content";
    }
}